module.exports = __webpack_public_path__ + "img/sl_slider6.52d51dc0.png";